import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaStore,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const SmallBusinessEcommerceWebsitesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Small Business E-commerce Websites in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Your Business</Subheading>}
        heading={
          <Heading>
            Small Business{" "}
            <span tw="text-primary-500">E-commerce Websites</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we empower small businesses in **DIFC** with
            affordable, high-quality e-commerce websites, designed to boost
            sales and establish a strong online presence in Dubai’s financial
            hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business owner with laptop
          "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop with products
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Local business success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Selling Online"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Tailored E-commerce for Small Businesses in DIFC"
        description="We deliver cost-effective solutions with big impact."
        cards={[
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Affordable Design",
            description: "Budget-friendly stores with premium features.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Focused",
            description: "Built to drive conversions for small businesses.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Support",
            description: "Guidance from DIFC’s e-commerce pros.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Setup",
            description: "Quickly launch your online store.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Ready",
            description: "Seamless shopping on all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Partner",
            description: "DIFC’s choice for small business success.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Small Business E-commerce Process"
        description={
          <Description>
            We create e-commerce websites with small businesses in mind:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your DIFC business goals.</li>
              <li>Design: Craft simple, effective layouts.</li>
              <li>Development: Build user-friendly, scalable stores.</li>
              <li>Testing: Ensure performance and ease of use.</li>
              <li>Launch: Get your store live quickly.</li>
              <li>Support: Offer ongoing help and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small team planning
          "https://images.unsplash.com/photo-1533750349088-cd871a92f312?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person working on laptop with coffee
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Mobile shopping experience
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Impact</Subheading>}
        heading="Small Business Wins in DIFC"
        description="Our e-commerce stores deliver results for startups."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Boost",
            description: "Tripled revenue for a DIFC startup.",
          },
          {
            icon: <FaStore color="#ff5464" size={40} />,
            title: "Brand Growth",
            description: "Expanded online reach for small retailers.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "97% satisfaction from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow?</Subheading>}
        heading="Small Business E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for small business e-commerce websites
            in DIFC. Get an affordable, high-performing store to take your
            business online—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small business in Dubai
          "https://images.unsplash.com/photo-1591085686350-798c0f9faa7f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Person managing online store
          "https://images.unsplash.com/photo-1539189017439-52ea067284a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Small shop inventory
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
